<template>
  <div class="policyInformation">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24">
        <Breadcrumbs :arr="['碳汇管理平台', '零碳+N']" />
      </el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <el-form-item label="姓名/单位">
            <el-input size="small" v-model="search.subscriptionName" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
           <el-form-item label="手机号">
            <el-input size="small" v-model="search.phone" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
           <el-form-item label="林场名称">
            <el-input size="small" v-model="search.policyTheme" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
          <!-- <el-form-item label="组织名称">
                        <el-cascader
                        ref="chooseOs"
                        :options="options"
                        @change='searchOrgChange'
                        :props="{ checkStrictly: true }"
                        :show-all-levels="false"
                        ></el-cascader>
                    </el-form-item> -->
          <el-form-item label="审核状态">
            <el-select v-model="search.checkStatus" clearable placeholder="请选择" size="small">
              <el-option label="全部" :value="0"> </el-option>
              <el-option label="已审核" :value="1"> </el-option>
              <el-option label="未审核" :value="2"> </el-option>
              <el-option label="无需审核" :value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付状态">
            <el-select v-model="search.payStatus" clearable placeholder="请选择" size="small">
              <el-option label="全部" :value="0"> </el-option>
              <el-option label="已支付" :value="1"> </el-option>
              <el-option label="待支付" :value="2"> </el-option>
              <el-option label="已取消" :value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item id="time" label="日期">
            <!-- <el-date-picker
                        v-model="search.time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        align="right"
                        style="width:280px;"
                        unlink-panels
                        size="small"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        >
                        </el-date-picker> -->
            <el-date-picker v-model="search.subscriptionTimeStart" type="date" size="small" format="yyyy-MM-dd"
              :picker-options="pickerOptionsYear" value-format="yyyy-MM-dd" style="width: 200px" placeholder="开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="search.subscriptionTimeEnd" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsYear1" style="width: 200px" placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn">
            <!-- class="theme-btn" -->
            <el-button size="small" type="primary" @click="getList" round>查询</el-button>
            <el-button size="small" style="margin: 0 0 0 50px" @click="reset" round type="info">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">
        <div class="table_btn">
          <!-- class="theme-btn" -->
          <el-button size="small" type="primary" @click="isExport()" round>导出</el-button>
        </div>
        <Tables class="table" :columns="columns" :loading="loading" :tableData="tableData">
          <template #checkStatus="scope">
            <div>{{ changeType(scope.row.checkStatus) }}</div>
          </template>
           <template #payStatus="scope">
            <div>{{ changeType1(scope.row.payStatus) }}</div>
          </template>
          <template #accessory="scope">
            <div class="operation" v-for="(item, index) in scope.row.accessory" :key="item.id">
              <a class="color pointer" :href="item.url" target="_blank">
                附件{{ index + 1 }}</a>
            </div>
          </template>
          <template #actions="scope">
            <div class="flex">
              <!-- <span class="theme-color">修改</span>
                            <span class="theme-color">删除</span>
                            <span class="theme-color">详情</span> -->
              <el-button type="text"  :disabled="scope.row.checkStatus!=0" @click="isDelete(scope.row.id)">审核</el-button>
              <el-button type="text" :disabled="scope.row.payStatus!=1" @click="isMark(scope.row.id)">备注</el-button>
            </div>
          </template>
        </Tables>
        <Paginations :pageData="pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
      </el-col>
    </el-row>
    <modaDialogl :dialog="dialog" :formData="formData" :handleClose="handleClose" :isView="isShowView" />
    <el-dialog title="导出" :visible.sync="dialogVisible" width="40%" :before-close="handleCloseExport">
      <el-form ref="form" :inline="true" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item id="time" label="选择日期" prop="payTimeStart" class="inlinitem">
          <el-date-picker v-model="form.payTimeStart" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            style="width: 200px" placeholder="开始日期" :picker-options="pickerOptions3">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="inlinitem" prop="payTimeEnd">
          <el-date-picker v-model="form.payTimeEnd" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            style="width: 200px" :picker-options="pickerOptions4" placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitExport">提交</el-button>
      </span>
    </el-dialog>
     <el-dialog title="备注" :visible.sync="markDialogVisible" width="40%" :before-close="markDialogVisibleClose">
      <el-form   label-width="100px" size="small">
        <el-form-item label="备注" class="inlinitem" prop="markValue">
          <el-input v-model="markValue" type="textarea" placeholder="请输入备注内容" 
            style="width: 100%;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="markDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitMark">提交</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>
import {
  carbonList,
  carbonDetail,
  carbonAudit,
  carbonExport,
  markVlaueAudit,
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue";
import Tables from "@/components/tables/tables.vue";
import modaDialogl from "./components/modaDialogl.vue";
import Paginations from "@/components/paginations/paginations.vue";
import { columns } from "./js/columns";
export default {
  name: "carbonUptake",
  data() {
    return {
      search: {
        subscriptionTimeEnd: "",
        subscriptionName: "",
        policyTheme:"",
        phone: "",
        payStatus:"",
        checkStatus:"",
        subscriptionTimeStart: "",
        type: "",
      },
      pickerOptionsYear: {
        disabledDate: (time) => {
          const start = Date.parse(this.search.subscriptionTimeStart);
          const end = Date.parse(this.search.subscriptionTimeEnd);
          if (this.search.subscriptionTimeEnd) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptionsYear1: {
        disabledDate: (time) => {
          const start = Date.parse(this.search.subscriptionTimeStart);
          const end = Date.parse(this.search.subscriptionTimeEnd);
          if (this.search.subscriptionTimeStart) {
            return (
              time.getTime() < start - 8.64e7
            );
          } else {
            // return time.getTime() > Date.now();
          }
        },
      },
      pickerOptions3: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.payTimeStart);
          const end = Date.parse(this.form.payTimeEnd);
          if (this.form.payTimeEnd) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptions4: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.payTimeStart);
          const end = Date.parse(this.form.payTimeEnd);
          if (this.form.payTimeStart) {
            return (
              time.getTime() < start - 1000 * 60 * 60 * 24
            );
          } else {
            // return time.getTime() > Date.now();
          }
        },
      },
      // 表格展示数据
      tableData: [],
      rules: {
        payTimeStart: [{ required: true, message: "选择开始日期" }],
        payTimeEnd: [{ required: true, message: "选择结束日期" }],
      },
      // rules1: {
      //   markValue: [{ required: true, message: "请填写备注", }],
      // },
      // 表格显示标题
      columns: [],
      rowId:'',
      loading: false,
      markValue: "",
      //备注弹框
      markDialogVisible: false,
      // 导出的弹出
      dialogVisible: false,
      // 弹出框设置
      dialog: {
        size: 720,
        visible: false,
        title: "新增",
      },
       form: {
        payTimeStart: "",
        payTimeEnd: "",
      },
      // 分页
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
      // 是否显示操作按钮
      isShowView: true,
      // 用户信息
      userInfo: {},
      // 表单信息
      formData: {},
    };
  },
  methods: {
    // 页面初始化
    init() {
      this.columns = columns;
      this.getList();
      let id = window.localStorage.getItem('policyInformation_detail_id')
      if (id) {
        this.isView(id)
        localStorage.removeItem('policyInformation_detail_id')
      }
    },
    // 备注弹出窗关闭
    markDialogVisibleClose(done) {
      this.markDialogVisible = false;
    },
    // 导出弹出窗关闭
    handleCloseExport(done) {
      this.dialogVisible = false;
    },
    // 备注的提交
    async submitMark() {
      let postData={
        id:this.rowId,
        remark: this.markValue
      }
      await markVlaueAudit(postData).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("提交成功");
          this.markDialogVisible = false;
          this.markValue = "";
          this.getList();
        } else {
          this.$message.error("提交失败");
        }
      });
      
    },
    // 导出的提交
    async submitExport() {
      let bol = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if (bol) {
          this.fileName = "碳汇+N"
          let form={...this.form}
          form.subscriptionTimeStart=form.payTimeStart+' 00:00:00'
          form.subscriptionTimeEnd=form.payTimeEnd+' 23:59:59'
          const res = await carbonExport(form)
          console.log(res)
          console.log(res.data)
          if (res.data.type == "application/vnd.ms-excel") {
            console.log(res)
            console.log(res.data)
            this.excel = res.headers['content-disposition']
            this.$message.success("导出成功");
            this.downloadFileExcel(res, this.fileName)
            this.excel = ""
            this.fileName = ""
            this.form.payTimeStart = ""
            this.form.payTimeEnd = ""
            this.dialogVisible = false
          } else this.$message.error("筛选范围暂无数据");
      }
    },
    changeType(type) {
      if (type == 0) return '未审核'
      else if (type == 1) return '已审核'
      else if (type == 2) return '无需审核'   
      else return ''
    },
    changeType1(type) {
      console.log(type)
      if (type == 0) return '待支付'
      else if (type == 1) return '已支付'
      else if (type == 2) return '已取消'   
      else retu
    },
    // 下载的方法
    downloadFileExcel(response, fileName) {
      const headers = response.headers;
      const contentType = headers['content-type'];
      const blob = new Blob([response.data], { type: contentType });
      const temp = response.headers['content-disposition'];
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(temp);
      let fileType = '';
      if (matches != null && matches[1]) {
        fileType = matches['input'].substring(matches['input'].lastIndexOf('.'));
      }
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = fileName + fileType; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    // 获取数据列表
    getList() {
      let page = {
        current: this.pageData.page,
        size: this.pageData.size,
      };
      this.loading = true
      this.search.subscriptionTimeStart = this.search.subscriptionTimeStart
        ? this.search.subscriptionTimeStart + " 00:00:00"
        : "";
      this.search.subscriptionTimeEnd= this.search.subscriptionTimeEnd
        ? this.search.subscriptionTimeEnd + " 23:59:59"
        : "";
      console.log(this.search)
      carbonList(this.search, page).then((res) => {
        if (res.data.code == "200") {
          console.log(res.data.data)
          this.tableData = res.data.data.records;

          // 解决文本带p标签问题,去掉所有的html标签
          // 使用正则去掉里面所有的html标签
          // const reg = /<\/?.+?\/?>/g
          // this.tableData.forEach(item => {
          //   item.policyContent = item.policyContent.replace(reg, '')
          // });

          this.pageData.total = res.data.data.total;
          this.tableData.forEach((item) => {
            item.accessory = item.accessory ? JSON.parse(item.accessory) : [];
          });
        }
        this.loading = false
      });
    },
    // 点击重置
    reset() {
      this.search = {
        endYear: "",
        policyTheme: "",
        startYear: "",
        type: "",
      };
      this.getList();
    },
    // 关闭弹出框
    handleClose() {
      this.dialog.visible = false;
    },
    // 新增
    isAddData() {
      this.formData = {
        policyTheme: "", // 政策主题
        startDate: "",
        endDate: "",
        policyContent: "", // 政策内容
        type: "", // 政策类型（0：政策信息发布，1：工作推进成果）
        accessory: "", // 附件
      };
      this.dialog.visible = true;
      this.isShowView = true;
      this.dialog.title = "新增";
    },
    // 修改
    async isEdit(id) {
      const res = await carbonDetail(id);
      if (res.data.code == 200) {
        this.formData = res.data.data;
        this.dialog.visible = true;
        this.dialog.title = "修改";
        this.isShowView = true;
      }
    },
    isMark(id){
      this.rowId = id;
      this.markDialogVisible=true;
    },
    // 详情
    async isView(id) {
      console.log(id)
      const res = await carbonDetail(id);
      if (res.data.code == 200) {
        this.formData = res.data.data;
        this.dialog.visible = true;
        this.dialog.title = "详情";
        this.isShowView = false;
      }
    },
    // 审核
    isDelete(id) {
      this.$confirm("是否审核通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          carbonAudit(id).then((res) => {
            if (res.data.code == 200) {
              // if (this.tableData.length == 1) {
              //   let page = this.pageData.page - 1;
              //   page = page <= 0 ? 0 : page;
              //   this.pageData.page = page;
              // }
              this.getList();
              this.$message({
                type: "success",
                message: "审核成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消审核",
          });
        });
    },
    //导出
    isExport() {
      this.dialogVisible = true;
      this.fileName = ""
      this.form.payTimeStart = ""
      this.form.payTimeEnd = ""
     
    },
    // 切换条数
    sizeChange(val) {
      this.pageData.size = val
      this.getList()
    },
    // 切换页数
    currentChange(val) {
      this.pageData.page = val
      this.getList()
    },
    setUrl(arr) {
      arr = JSON.parse(arr)
      if (arr.length)
        return arr[0].url
      else return ''
    },
  },
  mounted() {
    this.init();
  },
  components: {
    Breadcrumbs,
    Tables,
    modaDialogl,
    Paginations,
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.operation {
  color: #409EFF;
}
</style>
